import { h } from 'preact';
import { Router } from 'preact-router';

import Header from './header';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import Links from '../routes/links';

const App = () => (
	<div id="app">
		<Header />
		<Router>
			<Home path="/" />
			<Links path="/links/" />
		</Router>
	</div>
)

export default App;
